<template>
  <Modal
    appear
    @close="clickCancel"
    v-if="isOpenModal"
    class="p-contentplans-writing-edited-alert"
  >
    <template slot="content">
      <div>
        これまでの作業内容は破棄され、前回保存時の状態に戻ります。<br />
        本当に中断してよろしいですか？
      </div>
      <div class="c-modal-box__btns">
        <ButtonRectangle priority="low-white" @click="clickCancel">
          編集に戻る
        </ButtonRectangle>
        <ButtonRectangle priority="destructive" @click="clickQuit">
          中断する
        </ButtonRectangle>
      </div>
    </template>
  </Modal>
</template>

<script>
import ButtonRectangle from '@/components/ButtonRectangle';
import Modal from '@/components/Modal';
export default {
  components: {
    ButtonRectangle,
    Modal
  },
  data() {
    return {
      callback: {
        quit: null,
        cancel: null
      },
      isOpenModal: false
    };
  },
  methods: {
    clickCancel() {
      if (this.callback.cancel) {
        this.callback.cancel();
      }
      this.closeModal();
    },
    clickQuit() {
      if (this.callback.quit) {
        this.callback.quit();
      }
      this.closeModal();
    },
    closeModal() {
      this.isOpenModal = false;
    },
    openModal(callbackQuit, callbackCancel) {
      this.callback.quit = callbackQuit;
      this.callback.cancel = callbackCancel;
      this.isOpenModal = true;
    }
  }
};
</script>
